import { html, Component } from "../lib/index.js";

// Vnodes shouldn't be reused across multiple places in the tree at once
// (e.g. connect-form.js renders two password fields simultaneously), so
// these are functions returning a fresh vnode per call rather than
// module-level constants.
function eyeIcon() {
	return html`
		<svg width="1em" height="1em" viewBox="0 0 24 24"
			fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2 12C2 12 5.5 5 12 5C18.5 5 22 12 22 12C22 12 18.5 19 12 19C5.5 19 2 12 2 12Z"
				stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
		</svg>
	`;
}

function eyeOffIcon() {
	return html`
		<svg width="1em" height="1em" viewBox="0 0 24 24"
			fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3 3L21 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
			<path d="M10.6 5.2C11.05 5.1 11.52 5 12 5C18.5 5 22 12 22 12C22 12 21.18 13.58 19.6 15.16M6.6 6.6C3.8 8.4 2 12 2 12C2 12 5.5 19 12 19C13.5 19 14.8 18.6 15.9 18"
				stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9.9 10C9.35 10.5 9 11.2 9 12C9 13.66 10.34 15 12 15C12.8 15 13.5 14.65 14 14.1"
				stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	`;
}

// Wraps a password <input> with a show/hide toggle button, so users can
// verify what they typed instead of only seeing dots.
export default class PasswordInput extends Component {
	state = { visible: false };

	toggle(event) {
		event.preventDefault();
		this.setState((state) => ({ visible: !state.visible }));
	}

	render() {
		let visible = this.state.visible;
		return html`
			<span class="password-input">
				<input type=${visible ? "text" : "password"} ...${this.props}/>
				<button
					type="button"
					class="password-toggle"
					tabindex="-1"
					aria-label=${visible ? "Hide password" : "Show password"}
					title=${visible ? "Hide password" : "Show password"}
					onClick=${(event) => this.toggle(event)}
				>${visible ? eyeOffIcon() : eyeIcon()}</button>
			</span>
		`;
	}
}
